const TAP_LEARNED_KEY = 'gam_handshake_tap_learned';

/**
 * The finger over the handshake disc shows the tap until it has been made once.
 * Someone with handshakes already has made it, on whatever phone that was.
 */
export function shouldShowHandshakeTap(
  partnerCount: number,
  storage: Pick<Storage, 'getItem'> = localStorage,
): boolean {
  if (partnerCount > 0) return false;

  try {
    return storage.getItem(TAP_LEARNED_KEY) !== '1';
  } catch {
    return true;
  }
}

export function learnHandshakeTap(storage: Pick<Storage, 'setItem'> = localStorage): void {
  try {
    storage.setItem(TAP_LEARNED_KEY, '1');
  } catch {
    // A private window can refuse the write. The finger shows again next visit, which is harmless.
  }
}
